import { TaskGroup, WebSocketAction } from '@this+that/models';

export enum SyncAction {
  CREATE = 'create',
  UPDATE = 'update',
  REMOVE = 'remove',
  IGNORE = 'ignore',
}

export function taskGroupBelongsToActiveTeam(
  item: Pick<TaskGroup, 'teamId'>,
  activeTeamId: string | undefined,
): boolean {
  return !item.teamId || item.teamId === activeTeamId;
}

export function resolveSyncAction(
  event: WebSocketAction,
  { exists, belongs }: { exists: boolean; belongs: boolean },
): SyncAction {
  if (event === WebSocketAction.REMOVE) {
    return exists ? SyncAction.REMOVE : SyncAction.IGNORE;
  }

  if (!belongs) {
    return event === WebSocketAction.MODIFY && exists
      ? SyncAction.REMOVE
      : SyncAction.IGNORE;
  }

  return exists ? SyncAction.UPDATE : SyncAction.CREATE;
}
